import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import {
    ComboService,

    StockService
} from "../../../services/index";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./viewReprintBarcode.html",
  styleUrls: ["./viewReprintBarcode.scss"],
})
export class ViewReprintBarcodeComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  estimateFlag = false;
  seasonList = [];
  gridOptions: any;
  dataList = [];
  invType = ["wholesale", "estimate", "SalesReturn"]
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  box: boolean;
  shirt: boolean;
  reorderable: boolean = true;
  checked = false;
  start = 0;
  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter: any = {
    type: "FRESH",
    design_no: "",
    design_id: "",
    barcode: "",
    est_no : "",
    inv_type :"",
    rgrn_no : '',
    rgrn_date : ''
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,

    orderBy: "name",
    orderDir: "asc",
  };
  typeList = [{ name: "FRESH" }, { name: "DAMAGE" }];
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  designList: any;
  row: any;
  barList: any = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("filterAuto") filterAuto;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  filterControl: FormControl = new FormControl();
  colorControl: FormControl = new FormControl();
  partyControl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  designControl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  colorList: any;
  barcodeList: any = [];
  listSelected: any = [];
  printCount: any;

  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private stockService: StockService,
    private comboService: ComboService,
    public toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.getDesignCombo();
    // this.getStockViewList();
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
    //  this.partyDataTable.bodyHeight = 400;
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "",
        prop: "selected",
        headerCheckboxable: true,
        checkboxable: true,
        minWidth: 50,
        maxWidth: 50,
        width: 50,
        headerClass: "text-center",
        sortable: false,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Design No",
        prop: "dispName",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Barcode",
        prop: "barcode",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Size",
        prop: "size",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Color",
        prop: "color",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      //   { name: 'Action', prop: 'sno', minWidth: 100, maxWidth: 100, width: 100, sortable: false, cellTemplate: this.editDeleteTemplate },
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#design_no").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    //  this.getStockViewList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.color = "";
    this.filter.barcode = "";
    this.filter.est_no = "";
    this.filter.design_no = "";
    this.filter.design_id = "";
    this.filter.rgrn_no = "";
    this.filter.inv_type = "";
    this.filter.rgrn_date = "";
    this.filter.shade = "";
    //     this.columns[0].selected=[];
    // this.applyFilter();
    //   this.columns[0].selected=[];
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.barcodeList = [];
    this.listSelected = [];
    //  this.columns[0].selected=[];
    this.getStockViewList();

    if(this.filter.est_no){
      this.getestimatedata(this.filter.est_no);
    }
    if(this.filter.rgrn_no){
      this.getRgrndata(this.filter.rgrn_no);
    }
    //  this.columns[0].selected=[];
  }

  getStockViewList(): void {
    if (this.filter.color == "") {
      this.filter.design_id = "";
    }

    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));

    // if (that.estimateFlag == true) {
    //   that.getestimatedata(that.filter.est_no);
    // } 
    // else {
      let params = {
        start: `${this.page.offset * (this.page.limit + 1)}`,
        limit: `${this.page.limit}`,
        page: "1",
        design_no: this.filter.design_no,
        design_id: this.filter.design_id || 0,
        barcode: this.filter.barcode || 0,
        type: this.filter.type,
        code: this.filter.color,
      };
      if(params.design_id != 0 || params.design_no || params.barcode != 0){
        that.isLoadMask = that.stockService
        .getStockViewList(params)
        .then(function (res: any) {
          that.loadingIndicator = false;
          that.page.count = res.total;
          that.barcodeList = res.data;
          // this.columns[0].selected=[];
        });
      }
     
    // }
  }
  getestimatedata(data) {
    var temp = data.toString();
    var len = temp.length;
    // if (len > 7) {
      // var no = data.substr(7, len - 7);
      var no = data;
      let that = this;
      let params = {
        inv_no: no,
        start: that.start,
        inv_type:that.filter.inv_type,
        limit: `${this.page.limit}`,
        page: "1",
      };

      this.stockService.getestimatedata(params).then(function (res: any) {
        if (res.total > 0) {
          if (that.estimateFlag == false) {
            that.page.offset = 0;
          }

          that.estimateFlag = true;
          that.start += 25;
          if (res.rowsize < 25) {
            that.estimateFlag = false;
            that.start = 0;

            that.page.offset = 1;
          }
        } else {
          that.estimateFlag = false;
          that.start = 0;
        }
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.barcodeList = [];
        that.barcodeList = res.data;
      });
      console.log(no);
    // }
  }
  getRgrndata(data) {
    if(this.filter.rgrn_date){
        this.filter.rgrn_date = this.datePipe.transform(
        this.filter.rgrn_date,
        "yyyy-MM-dd"
      );
    }else{
      swal("Please Select Rgrn date");
      return;
    }
   
    var temp = data.toString();
    var len = temp.length;
    // if (len > 7) {
      // var no = data.substr(7, len - 7);
      var no = data;
      let that = this;
      let params = {
        rgrn_no: no,
        rgrn_date : this.filter.rgrn_date ,
        start: that.start,
        shade: this.filter.shade,

        limit: `${this.page.limit}`,
        page: "1",
      };

      this.stockService.getRgrndata(params).then(function (res: any) {
        if (res.total > 0) {
          if (that.estimateFlag == false) {
            that.page.offset = 0;
          }

          that.estimateFlag = true;
          that.start += 25;
          if (res.rowsize < 25) {
            that.estimateFlag = false;
            that.start = 0;

            that.page.offset = 1;
          }
        } else {
          that.estimateFlag = false;
          that.start = 0;
        }
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.barcodeList = [];
        that.barcodeList = res.data;
      });
      console.log(no);
    // }
  }
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.barcodeList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
      // this.barcodeList = []
    }
  }
  checkInd(evant, ind, all) {
    if (evant.target.checked) {
      this.listSelected = this.listSelected.concat(all.barcodeList[ind]);
    } else {
      //         this.listSelected.forEach(element => {
      //   if(all.barcodeList[ind].barcode == element.barcode){
      //   this.listSelected.splice()
      //   }
      //         });

      for (let i = 0; i < this.listSelected.length; i++) {
        let element = this.listSelected[i];
        if (all.barcodeList[ind].barcode == element.barcode) {
          this.listSelected.splice(i, 1);
        }
      }
    }
  }
  getDesignCombo(): void {
    let that = this;
    this.isLoadMask = this.comboService
      .getDesignCombo({})
      .then(function (res: any) {
        that.loadingIndicator = false;
        //  that.page.count = res.total;
        that.designList = res;
      });
  }
  getDesignColorCombo(design_no): void {
    this.filter.color = "";
    let that = this;
    let params = {
      design_no: design_no,
    };
    this.isLoadMask = this.comboService
      .getDesignComboColor(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        // that.page.count = res.total;
        that.colorList = res;
        $("#designcolor").focus();
      });
  }

  getDesignId(color) {
    // console.log(typeof color);
    //  let color_code = color.substring(1, color.length-1);
    $("#barcode").focus();
    let codeList = _.filter(this.colorList, { code: color });
    this.filter.design_id = codeList[0]["design_id"];
  }

  deleteDesignStock() {
    this.filterPanel.close();
    if (this.listSelected.length <= 0) {
      this.filterPanel.close();
      swal({
        title: "Please Select Atleast One Design No",
        // text: 'How much barcode label is needed?',
        // showCancelButton: true,
        customClass: "swal-wide",
        // confirmButtonText: 'Single',
        cancelButtonText: "OK",
        cancelButtonColor: "rgb(48, 133, 214)",
      }).then(
        function () {
          this.filterPanel.close();
          //
        },
        function (dismiss) {
          this.filterPanel.close();
          if (dismiss == "cancel") {
            this.filterPanel.close();
          }
        }
      );
    } else {
      let params = {
        designdet: JSON.stringify(this.listSelected),
      };

      let that = this;
      that.filterPanel.close();
      swal({
        title: "Are you sure to delete this Design Details?",
        text: "You will not be able to recover this details",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then(
        function () {
          that.filterPanel.close();
          that.isLoadMask = that.stockService
            .deleteDesignStock(params)
            .then(function (res: any) {
              that.filterPanel.close();
              that.loadingIndicator = false;
              that.filterPanel.close();
              //          that.partyDataTable.selected = [];
              that.listSelected = [];
              that.applyFilter();

              let errtype = "success",
                errmsg = res.message;
              if (!res.success) {
                that.filterPanel.close();
                errtype = "error";
              }

              that.toasterService.pop({
                bodyOutputType: 1,
                type: errtype,
                title: errtype.toUpperCase(),
                body: errmsg,
              });
            });
        },
        function (dismiss) {
          that.filterPanel.close();
        }
      );
    }
  }

  onSelect($event) {
    this.listSelected = $event.selected;
    $event.selected = [];
  }
  printer() {
    let that = this;
    if (that.listSelected.length <= 0) {
      that.filterPanel.close();

      swal({
        title: "Please Select Atleast One Design No",
        // text: 'How much barcode label is needed?',
        // showCancelButton: true,
        customClass: "swal-wide",
        // confirmButtonText: 'Single',
        cancelButtonText: "OK",
        cancelButtonColor: "rgb(48, 133, 214)",
      }).then(
        function () {
          that.filterPanel.close();
          //
        },
        function (dismiss) {
          that.filterPanel.close();
          if (dismiss == "cancel") {
            that.filterPanel.close();
          }
        }
      );
    } else {
      $("#printpr").show();
    }
  }

  printBarcode() {
    // let that = this;
    // that.filterPanel.close();
    // if (that.listSelected.length <= 0) {
    //     // $('#printpr').modal('hide');
    //     that.filterPanel.close();

    //     swal({
    //         title: 'Please Select Atleast One Design No',
    //         // text: 'How much barcode label is needed?',
    //         // showCancelButton: true,
    //         customClass: 'swal-wide',
    //         // confirmButtonText: 'Single',
    //         cancelButtonText: 'OK',
    //         cancelButtonColor: "rgb(48, 133, 214)",
    //     }).then(function () {
    //         that.filterPanel.close();
    //         //
    //     }, function (dismiss) {
    //         that.filterPanel.close();
    //         if (dismiss == 'cancel') {
    //             that.filterPanel.close();
    //         }
    //     });
    // }
    // else {
    //   $("#printpr").modal('show');

    if ($("#box").is(":checked")) {
      this.box = true;
    } else {
      this.box = false;
    }
    if ($("#shirt").is(":checked")) {
      this.shirt = true;
    } else {
      this.shirt = false;
    }
    if (this.box == false && this.shirt == false) {
      swal("PLEASE SELECT ATLEAST ONE");
    } else {
      $("#box").prop("checked", false);
      $("#shirt").prop("checked", false);
      this.filterPanel.close();
      console.log("success");
      this.printCount = 1;
      this.print();
      $("#printpr").hide();
      // this.listSelected = [];
      // this.getestimatedata(this.filter.est_no);
      this.columns[0].selected = [];
      // this.barcodeList = [];
    }

    // let that = this;

    // swal({
    //     title: 'Select Quantity',
    //     text: 'How much barcode label is needed?',
    //     showCancelButton: true,
    //     customClass: 'swal-wide',
    //     confirmButtonText: 'Shirt',
    //     cancelButtonText: 'Box',
    //     cancelButtonColor: "rgb(48, 133, 214)",

    // })
    // function when confirm button clicked

    //  function (dismiss) {
    //     if (dismiss == 'cancel') {
    //         // function when cancel button is clicked
    //         console.log('error');
    //         that.printCount = 2;
    //         that.print();
    //         //     that.listSelected = [];
    //         //     that.columns[0].selected=[];
    //         that.barcodeList = [];
    //     }
    // });
    // }
  }

  closed(): void {
    $("#printpr").hide();
  }
  print() {
    let that = this;
    that.filterPanel.close();
    let params = {
      designdet: JSON.stringify(that.listSelected),
      export: that.checked,
      noofpcs: that.printCount,
      box: this.box,
      shirt: this.shirt,
      // mfg_date : true
    };
    that.listSelected = [];
    that.isLoadMask = that.stockService.print(params).then(function (res: any) {
      $("#checkTot").prop("checked", false);
      // that.listSelected = [];
      //    that.columns[0].selected=[];
      //    that.barcodeList = [] ;
    });
  }
  click(checked) {
    if (checked == true) {
      this.checked = true;
    } else {
      this.checked = false;
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/ViewReprintBarcode/viewReprintBarcode.ts